const role = {
    super_admin:'super_admin',
    admin: 'admin',
    manager: 'manager',
    seller: 'seller',
    user: 'user',
    law_body: 'law_body'
};

export default role;